/* eslint-disable @typescript-eslint/no-explicit-any */
import { RaceTable } from 'features/Race/components'
import { guildVaultTableNftColumns } from 'utils/columns'
import { useAppDispatch, useAppSelector, useToggle, useUpdateEffect } from 'hooks'
import React, { memo, useEffect, useMemo, useState } from 'react'
import { GetRaceListParams } from 'models'
import { NUMBER, STRING } from 'apps/constants'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { useTranslation } from 'react-i18next'
import { notification } from 'antd'
import { useSelector } from 'react-redux'
import { errorNftListTable, getNftListTable } from 'apps/redux/userCreateRace/selector'
import { getNftList } from 'apps/redux/userCreateRace/action'
import ModalDetailNft from '../Modals/DetailNft'

const defaultParams: GetRaceListParams = {
  limit: NUMBER.TWENTY,
  page: NUMBER.ONE
}

function TableNft(props: { filters: { filterTypeNft: string; filterRarityNft: string } }) {
  const {
    filters: { filterTypeNft, filterRarityNft }
  } = props
  const [api, contextHolder] = notification.useNotification()
  const { t } = useTranslation()
  const { profile } = useAppSelector(state => state)
  const [dataTable, setDataTable] = useState<any>([])
  const [params, setParams] = useState<GetRaceListParams>(defaultParams)
  const [loading, setLoading] = useState<boolean>(false)
  const [total, setTotal] = useState()
  const dispatch = useAppDispatch()
  const dataNftTable = useSelector(getNftListTable)
  const errorNft = useSelector(errorNftListTable)
  const [isModalDetail, setIsModalDetail] = useToggle(false)
  const [rowSelected, setRowSelected] = useState<any>(undefined)

  const memoizedResultListSelectionColumns = useMemo(() => {
    return guildVaultTableNftColumns
  }, [profile])

  useEffect(() => {
    setParams({
      ...params,
      page: 1,
      rarity: ['All', 'Rarity'].includes(filterRarityNft) ? '' : filterRarityNft,
      type: ['All', 'Type'].includes(filterTypeNft) ? '' : filterTypeNft
    })
  }, [filterRarityNft, filterTypeNft])

  useEffect(() => {
    if (profile.guild_id !== NUMBER.ZERO) {
      setLoading(true)
      getListDataTable()
    }
  }, [params, profile.guild_id])

  useEffect(() => {
    if (errorNft) {
      openNotification(STRING.ERROR, errorNft)
    }
  }, [errorNft])

  useEffect(() => {
    if (dataNftTable?.records) {
      setLoading(false)
      const formatData = dataNftTable?.records.map((record: any) => {
        return {
          ...record,
          coin_type: record.rarity_type
        }
      })
      setDataTable(params.page > NUMBER.ONE ? [...dataTable, ...formatData] : formatData)
      setTotal(dataNftTable?.total || NUMBER.ZERO)
    }
  }, [dataNftTable])

  const openNotification = (message: string, description: string) => {
    notification.config({
      duration: NUMBER.FOUR
    })

    api.info({
      message,
      description,
      placement: 'bottomRight',
      className: message === STRING.ERROR ? 'ant-custom-error' : 'ant-custom-success'
    })
  }

  const getListDataTable = async () => {
    dispatch(getNftList({ guildId: profile.guild_id, params }))
  }

  useUpdateEffect(() => {
    setParams({ ...params, page: NUMBER.ONE })
  }, [])

  const handleClickRow = async (row: any) => {
    setIsModalDetail(true)
    setRowSelected(row)
  }

  return (
    <div>
      {contextHolder}
      <RaceTable
        columns={memoizedResultListSelectionColumns}
        data={dataTable}
        raisePage={setParams}
        loader={!loading}
        params={params}
        checkLoadingPage={false}
        totalRace={total}
        currentUser={profile}
        noDataText={t(`${NOTIFICATION_MESSAGE}.dataNotFound`)}
        isShowVipIcon={true}
        isRowClickable
        isHorseTable
        onRowClick={handleClickRow}
      />
      {isModalDetail && (
        <ModalDetailNft
          rowSelected={rowSelected}
          onCloseButtonClick={() => setIsModalDetail(false)}
          toggleIsModalOpen={setIsModalDetail}
        />
      )}
    </div>
  )
}

export default memo(TableNft)
